var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 12.2917C27.4168 12.2917 29.3752 14.25 29.3752 16.6667C29.3752 19.0834 27.4168 21.0417 25.0002 21.0417C22.5835 21.0417 20.6252 19.0834 20.6252 16.6667C20.6252 14.25 22.5835 12.2917 25.0002 12.2917ZM25.0002 31.0417C31.1877 31.0417 37.7085 34.0834 37.7085 35.4167V37.7084H12.2918V35.4167C12.2918 34.0834 18.8127 31.0417 25.0002 31.0417ZM25.0002 8.33337C20.396 8.33337 16.6668 12.0625 16.6668 16.6667C16.6668 21.2709 20.396 25 25.0002 25C29.6043 25 33.3335 21.2709 33.3335 16.6667C33.3335 12.0625 29.6043 8.33337 25.0002 8.33337ZM25.0002 27.0834C19.4377 27.0834 8.3335 29.875 8.3335 35.4167V39.5834C8.3335 40.7292 9.271 41.6667 10.4168 41.6667H39.5835C40.7293 41.6667 41.6668 40.7292 41.6668 39.5834V35.4167C41.6668 29.875 30.5627 27.0834 25.0002 27.0834Z",
    fill: "#2FBCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.029538c124927359f63e6d50e938f821.svg";
export { ForwardRef as ReactComponent };